import { atomWithRefresh } from 'jotai/utils';
import { guardedClient } from '../../auth/api/clients';
import { type User } from '../../auth/authAtom';
const isUserArray = (v: unknown): v is User[] => {
  if (!Array.isArray(v)) return false;
  return v.every(item => {
    if (!item || typeof item !== 'object') return false;
    const r = item as Record<string, unknown>;
    return (
      typeof r.id === 'number' &&
      typeof r.name === 'string' &&
      typeof r.email === 'string' &&
      typeof r.isActive === 'boolean'
    );
  });
};

export const usersAtom = atomWithRefresh(async () => {
  const response = await guardedClient.users.$get();
  if (!response.ok) throw new Error('Failed to load users status=' + String(response.status));
  const raw = await response.json();
  if (!isUserArray(raw)) throw new Error('Invalid users response');
  return [...raw].sort((a, b) => a.id - b.id);
});
